import React, { useState, useEffect } from 'react';
import Button from '../../../../../ui/canon/Button';
import { SendIcon } from 'lucide-react';

const CurrencySliderWidget = ({
  onAnswer,
  disabled,
  min = 0,
  max = 10000000,
  step = 100000,
  defaultValue,
  label = 'Estimated Value',
  initialValue = null,
}) => {
  // Initialize state - prefer initialValue (for editing), then defaultValue, then min
  const getInitialValue = () => {
    if (initialValue !== null && initialValue !== undefined) {
      return typeof initialValue === 'number' ? initialValue : Number(initialValue) || min;
    }
    if (defaultValue !== undefined) return defaultValue;
    return min;
  };
  
  const [value, setValue] = useState(getInitialValue);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setValue(getInitialValue());
    setIsSubmitting(false);
  }, [initialValue]);

  const formatCurrency = (val) => {
    if (val >= 1000000) {
      return `$${(val / 1000000).toFixed(1)}M`;
    }
    if (val >= 1000) {
      return `$${(val / 1000).toFixed(0)}K`;
    }
    return `$${val}`;
  };

  const handleSubmit = () => {
    if (!isSubmitting) {
      setIsSubmitting(true);
      onAnswer({ value: value, formatted: formatCurrency(value) });
    }
  };

  const handleSliderChange = (e) => {
    setValue(Number(e.target.value));
  };

  // Calculate percentage for slider background track if needed
  const percentage = ((value - min) / (max - min)) * 100;

  return (
    <div className="space-y-6 w-full max-w-md">
      <div className="flex items-end justify-between">
        <span className="text-sm font-medium text-succession-text-secondary">{label}</span>
        <span className="text-3xl font-bold text-succession-text-primary">
          {formatCurrency(value)}
        </span>
      </div>

      <div className="relative w-full h-6 flex items-center">
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={handleSliderChange}
          disabled={disabled || isSubmitting}
          className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-succession-primary focus:outline-none focus:ring-2 focus:ring-succession-focus-ring"
          style={{
            background: `linear-gradient(to right, var(--succession-primary, #000) 0%, var(--succession-primary, #000) ${percentage}%, #e5e7eb ${percentage}%, #e5e7eb 100%)`
          }}
        />
      </div>

      <div className="flex justify-between text-xs text-succession-text-muted">
        <span>{formatCurrency(min)}</span>
        <span>{formatCurrency(max)}</span>
      </div>

      <Button
        onClick={handleSubmit}
        disabled={disabled || isSubmitting}
        className="w-full"
      >
        <SendIcon className="h-4 w-4 mr-2" />
        Submit Answer
      </Button>
    </div>
  );
};

export default CurrencySliderWidget;
